// extracted by mini-css-extract-plugin
export default {"item":"prn3VB","button":"spePly","disabled":"SPiFZG","active":"HXYsaa"};